import { render } from "./app.vue?vue&type=template&id=5ef48958"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=5ef48958&lang=less"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.11_vue@3.2.11_webpack@5.109.2_postcss@8.5.26_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ef48958"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ef48958', __exports__)) {
    api.reload('5ef48958', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=5ef48958", () => {
    api.rerender('5ef48958', render)
  })

}


export default __exports__